const RUN_ERROR_CODE_TOAST_DETAIL: Record<string, string> = {
  string_above_max_length: 'Context window limit reached. Please remove some files and try again.',
};

const FAILED_RESPONSE_TOAST_DETAIL = 'Error: Fletch failed to generate a response.';

const extractOpenAiStyleErrorCode = (message: string): string | null => {
  const match = message.match(/['"]code['"]\s*:\s*['"]([^'"]+)['"]/);
  return match?.[1] ?? null;
};

/** Errors with their own copy keep it; anything else is raw error text, so it gets the generic message. */
export const getToastDetailForChatRunError = (message: string): string => {
  const code = extractOpenAiStyleErrorCode(message);
  return (code && RUN_ERROR_CODE_TOAST_DETAIL[code]) || FAILED_RESPONSE_TOAST_DETAIL;
};
